import { useState } from "react";
import { saveRoleDetails } from "../Api/RoleMaster";
import { Container, Form, Button, Row, Col, Accordion, AccordionBody, AccordionItem, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const RoleMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [roleData, setRoleData] = useState({
    code: "",
    description: "",
  });

  const handleChange = (e) => {
    setRoleData({ ...roleData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveRoleDetails(roleData);
      toast.success("🦄 Role Added Successfully!");
      setRoleData({ code: "", description: "" });
      navigate("/viewRoleMaster");
    } catch (error) {
      toast.error("🦄 Error saving role details!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h2 className="fields-title">Role Master</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion defaultActiveKey="0">
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Code <span className="text-red">**</span></Form.Label>
                      <Form.Control
                        type="text"
                        name="code"
                        value={roleData.code}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Description <span className="text-red">**</span></Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={roleData.description}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button variant="primary" type="submit" className="fields-submit" disabled={loading}>
              {loading ? (
                <><Spinner animation="border" size="sm" className="me-2" />Saving…</>
              ) : "Save Role"}
            </Button>
          </div>
        </Form>
      </Container>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default RoleMaster;